export default [
    { key: 'accounting', title: 'Accounting & Financial' },
    { key: 'agriculture', title: 'Agriculture' },
    { key: 'animals', title: 'Animal & Pet' },
    { key: 'architectural', title: 'Architectural' },
    { key: 'art', title: 'Art & Design' },
    { key: 'attorney', title: 'Attorney & Law' },
    { key: 'automotive', title: 'Automotive' },
    { key: 'bar', title: 'Bar & Nightclub' },
    { key: 'business', title: 'Business & Consulting' },
    { key: 'children', title: 'Childcare' },
    { key: 'cleaning', title: 'Cleaning & Maintenance' },
    { key: 'communications', title: 'Communications' },
    { key: 'community', title: 'Community & Non-Profit' },
    { key: 'computer', title: 'Computer' },
    { key: 'construction', title: 'Construction' },
    { key: 'cosmetics', title: 'Cosmetics & Beauty' },
    { key: 'dating', title: 'Dating' },
    { key: 'education', title: 'Education' },
    { key: 'entertainment', title: 'Entertainment & The Arts' },
    { key: 'environment', title: 'Environmental' },
    { key: 'fashion', title: 'Fashion' },
    { key: 'floral', title: 'Floral' },
    { key: 'food', title: 'Food & Drink' },
    { key: 'games', title: 'Games & Recreational' },
    { key: 'home', title: 'Home Furnishing' },
    { key: 'industrial', title: 'Industrial' },
    { key: 'internet', title: 'Internet' },
    { key: 'landscaping', title: 'Landscaping' },
    { key: 'medical', title: 'Medical & Pharmaceutical' },
    { key: 'photography', title: 'Photography' },
    { key: 'physical', title: 'Physical Fitness' },
    { key: 'politics', title: 'Political' },
    { key: 'realestate', title: 'Real Estate & Mortgage' },
    { key: 'religious', title: 'Religious' },
    { key: 'restaurant', title: 'Restaurant' },
    { key: 'retail', title: 'Retail' },
    { key: 'security', title: 'Security' },
    { key: 'spa', title: 'Spa & Esthetics' },
    { key: 'sports', title: 'Sport' },
    { key: 'technology', title: 'Technology' },
    { key: 'travel', title: 'Travel & Hotel' },
    { key: 'wedding', title: 'Wedding Service' },
];
